@if (linkUrl()) {
    <a 
        [routerLink]="linkUrl()" 
        [severity]="type()" 
        [size]="size()" 
        [pTooltip]="tooltipLabel()" 
        [tooltipPosition]="tooltipPosition()" 
        [showDelay]="tooltipOpt.showDelay" 
        [fluid]="fluid()"
        [attr.aria-label]="ariaLabel() || null"
        pButton 
        pRipple>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
} @else {
    <button
        [disabled]="disabled()"
        [severity]="type()" 
        [size]="size()" 
        [pTooltip]="tooltipLabel()" 
        [tooltipPosition]="tooltipPosition()" 
        [showDelay]="tooltipOpt.showDelay" 
        [fluid]="fluid()"
        [attr.aria-label]="ariaLabel() || null"
        pButton 
        pRipple>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
}

<ng-template #content>
    @if (icon()) {
        <span [class]="icon()" pButtonIcon></span>
    }
    @if (label()) {
        <span pButtonLabel>{{ label() }}</span>
    }
</ng-template>